const i18n = {
  'en-US': {
    'menu.dashboard': 'Dashboard',
    'menu.dashboard.workplace': 'Workplace',
    'menu.user.info': 'User Info',
    'menu.user.setting': 'User Setting',
    'menu.user.switchRoles': 'Switch Roles',
    'menu.user.role.admin': 'Admin',
    'menu.user.role.user': 'General User',
    'navbar.logout': 'Logout',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Click to use light mode',
    'settings.navbar.theme.toDark': 'Click to use dark mode',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent': 'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message': 'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip': '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search',
    'menu.account-admin': 'Mine Admin',
    'menu.channel': 'Channel',
    'menu.channel.admin': 'Channel Add',
    'menu.channel.list': 'Channel Info',
    'menu.chart': 'Chart Data',
    'chart.main-chart': 'Main Chart',
    'chart.open-mch': 'Open Mch Chart',
    'chart.performance-rank': 'Performance Rank Chart',
    'chart.e-commerce-share': 'E-Commerce Share Chart',
    'chart.scatter': 'Scatter Chart',
    'menu.merchant0': 'Merchant Admin',
    'menu.settlement': 'Reconciliation Center',
    'menu.settlement.list': 'Reconciliation Data',
    'menu.settlement.admin': 'Reconciliation Admin',
    'menu.merchant': 'Merchant Admin',
    'menu.sales-agent': 'Merchant Supply',
    'menu.merchant.join': 'Merchant Settled',
    'menu.merchant.income': 'Merchant Income',
    'menu.merchant.list': 'Merchant Info',
    'menu.merchant.mch-agent-set-list': 'Merchant Config List',
    'menu.merchant.instead-pay': 'Instead Pay',
    'menu.salesagent.list': 'Supply List',
    'menu.salesagent.instead-supply': 'Supply Instead Pay',
    'menu.salesagent.withdraw-supply': 'Supply Withdraw',
    'menu.merchant.fund-transfer': 'Fund Transfer',
    'menu.merchant.withdraw': 'Withdraw',
    'merchant.virtual-account': 'Merchant VirtualAccount',
    'merchant.virtual-account-withdraw': 'Do WithDraw',
    'merchant.virtual-account-detail': 'Fund Order',
    'merchant.withdraw-member': 'Withdraw Partner',
    'merchant.protocol': 'Protocol Admin',
    'merchant.withdraw-member-card': 'Withdraw Card Admin',
    'menu.agent': 'Agent Admin',
    'menu.agent.admin': 'Agent Add',
    'menu.agent.list': 'Agent List',
    'menu.agent.channel-agent-set': 'Agent Product Admin',
    'menu.agent.channel-agent-set-list': 'Agent Product Info',
    'menu.setting': 'System Config',
    'menu.setting.dash': 'System Config Dash',
    'menu.setting.dash.channel': 'Set Service Provider',
    'menu.setting.dash.joinForm': 'Set Income Form',
    'menu.setting.dash.e-commerce': 'Set ECommerce Form',
    'menu.setting.dash.sms': 'Sms Channel',
    'menu.setting.dash.idp2': '2 Elements InsteadPay',
    'menu.setting.agent': 'System Config Agent',
    'menu.setting.agent.mch_switch': 'Mch Transfer',
    'menu.adv': 'Advertise',
    'menu.risk': 'Risk Admin',
    'menu.risk.review': 'Review Admin',
    'menu.adv.admin': 'Advertise Admin',
    'menu.adv.clues': 'Advertise Clues',
    'menu.adv.connect': 'Advertise Connect'
  },
  'zh-CN': {
    'menu.dashboard': '账户总览',
    'menu.dashboard.workplace': '工作台',
    'menu.user.info': '用户信息',
    'menu.user.setting': '用户设置',
    'menu.user.switchRoles': '切换角色',
    'menu.user.role.admin': '管理员',
    'menu.user.role.user': '普通用户',
    'navbar.logout': '退出登录',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '点击切换为亮色模式',
    'settings.navbar.theme.toDark': '点击切换为暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent': '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message': '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip': '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询',
    'menu.account-admin': '信息管理',
    'menu.channel': '服务商管理',
    'menu.channel.list': '服务商信息',
    'menu.channel.product-admin': '服务商配置',
    'menu.channel.product-list': '服务商配置信息',
    'menu.chart': '数据图表',
    'chart.main-chart': '商户数据',
    'chart.open-mch': '开户数据',
    'chart.performance-rank': '业绩数据',
    'chart.e-commerce-share': '电商数据',
    'chart.scatter': '大盘数据',
    'menu.merchant0': '商户管理',
    'menu.settlement': '结算中心',
    'menu.settlement.admin': '结算管理',
    'menu.settlement.list': '结算数据',
    'menu.merchant': '商户管理',
    'menu.sales-agent': '园区集采',
    'menu.merchant.join': '创建商户',
    'menu.merchant.join-supply': '创建集采商',
    'menu.merchant.income': '商户信息',
    'menu.merchant.list': '系统商户信息',
    'menu.merchant.mch-agent-set-list': '系统商户产品信息',
    'menu.merchant.instead-pay': '资金代付',
    'menu.salesagent.list': '集采商列表',
    'menu.salesagent.instead-supply': '集采商代付',
    'menu.salesagent.withdraw-supply': '集采商提现',
    'menu.merchant.fund-transfer': '资金调拨',
    'menu.merchant.withdraw': '提现管理',
    'merchant.virtual-account': '虚拟户管理',
    'merchant.virtual-account-withdraw': '发起提现',
    'merchant.virtual-account-detail': '资金订单',
    'merchant.split-order': '订单录入',
    'merchant.withdraw-member': '供应商开户',
    'merchant.withdraw-member-white': '白名单开户',
    'merchant.withdraw-member-list': '供应商信息',
    'merchant.protocol': '协议管理',
    'merchant.withdraw-member-card': '银行卡管理',
    'menu.agent': '代理商管理',
    'menu.agent.admin': '添加代理商',
    'menu.agent.list': '代理商信息',
    'menu.agent.channel-agent-set': '代理商产品配置',
    'menu.agent.channel-agent-set-list': '代理商产品信息',
    'menu.setting': '系统设置',
    'menu.setting.dash': '配置面板',
    'menu.setting.dash.channel': '服务商配置',
    'menu.setting.dash.joinForm': '开户表单配置',
    'menu.setting.dash.e-commerce': '入金配置',
    'menu.setting.dash.sms': '短信通道',
    'menu.setting.dash.idp2': '二要素代付',
    'menu.setting.agent': '代理配置',
    'menu.setting.agent.mch_switch': '商户转交',
    'menu.setting.agent.mch_input': '商户录入',
    'menu.risk': '风控管理',
    'menu.risk.review': '审核管理',
    'menu.adv': '推广服务',
    'menu.adv.admin': '推广管理',
    'menu.adv.clues': '线索信息',
    'menu.adv.connect': '官网线索'
  }
};
export default i18n;